export class ScenarioVersion {
  constructor(private readonly path: string) {}

  static ScenarioVersion() {
    return new ScenarioVersion("/v1/scenarioVersion");
  }

  getScenarioVersionById(versionId: string): string {
    return `${this.path}/${versionId}`;
  }

  postScenarioVersion(): string {
    return `${this.path}`;
  }
}
